export default __webpack_public_path__ + "static/media/pdf.b173c9d7.svg";